module.exports = __webpack_public_path__ + "assets/profile4.902f7550.svg";